import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { E2emechanizationService } from 'src/app/services/e2emechanization.service';
import { SecurityService } from 'src/app/services/security.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-farmerdetails',
  templateUrl: './farmerdetails.component.html',
  styleUrls: ['./farmerdetails.component.scss']
})
export class FarmerdetailsComponent implements OnInit {
  farmerbookingList: any;
  farmerId: number;
  routeParams: any;
  farmerdetailList: any;
  selectedStage: any;
  selectStage: any;

  datafield: any;
  imageBaseUrl = environment.imageBaseUrl;
  attachments: any[] = [];
  groupedAttachments: any[] = [];
  attachmentTypeNames: any[] = [];
  datafield1: any;
  environment: any;
  farmerpaymentList: any
  isImageModalOpen = false;
  isImageWorkPlaceOpen = false;
  selectedImage: any = null;

  constructor(
    private e2emechanizationService: E2emechanizationService,
    private securityService: SecurityService,

    route: ActivatedRoute,
    private router: Router,

  ) {
    this.routeParams = route.snapshot.params;
    // this.farmerId = this.routeParams.id;
    const decId = this.securityService.decrypt(this.routeParams.id);
    this.farmerId = decId
  }

  ngOnInit(): void {
    this.getFarmerEventList(this.farmerId);
    this.getFarmerList(this.farmerId);
    this.getPaymentDetailList(this.farmerId);

  }

  getFarmerEventList(farmerId: number) {
    this.e2emechanizationService.getFarmerEventList(farmerId, true).subscribe((res) => {
      if (res) {
        this.farmerbookingList = res;
        this.farmerbookingList.forEach(element => {
          if (element.id === 2 && element.isShow) {
            const visibleSubStages = element.subStageList.filter(e => e.isShow);
            element.subStageList = []
            element.subStageList = [...visibleSubStages];
          } else if (element.id === 2 && !element.isShow) {
            const hiddenSubStages = element.subStageList.filter(e => !e.isShow);

            if (hiddenSubStages.length > 1) {
              const combinedName = hiddenSubStages.map(e => e.e2ESubStageName).join(" / ");
              element.subStageList = []
              element.subStageList = [
                {
                  id: 0,
                  e2ESubStageName: combinedName,
                  eventList: [],
                  isShow: false
                }
              ];
            }
          }
        });

        if (this.farmerbookingList?.length > 0) {
          this.selectedStage = this.farmerbookingList[0];
        }
      }
    });
  }

  back() {
    this.router.navigate(["/e2efarmerdetails"]);
  }

  getFarmerList(farmerId) {
    const res = this.e2emechanizationService.getFarmerDetailList(farmerId, true).subscribe((res) => {
      if (res) {
        this.farmerdetailList = res;
        this.datafield = res;
      }
    });
  }


  getPaymentDetailList(farmerId: number) {
    this.e2emechanizationService.getPaymentDetailList(farmerId, true).subscribe((res) => {
      if (res) {
        this.farmerpaymentList = res;
        if (this.farmerpaymentList?.length > 0) {
          this.selectStage = this.farmerpaymentList[0];
        }
      }
    });
  }


  getBillImage(imagePath: string): string {
    return imagePath ? `${this.imageBaseUrl}/E2E/E2EPaymentChallan/${imagePath}` : '';
  }
  toggleStage(stage: any) {
    this.selectedStage = stage;
  }


  toggleStage1(stage: any) {
    this.selectStage = stage;
  }
  openImage() {
    this.isImageModalOpen = true;

  }
  closeImage() {
    this.isImageModalOpen = false;

  }

  openWorkPlaceImage(img: any, type: string) {
    this.selectedImage = {
      url: this.imageBaseUrl + (type === 'before'
        ? 'E2E/E2EBeforeWorkPlace/'
        : 'E2E/E2EAfterWorkPlace/') + img.attachmentFileName,
      alt: img.attachmentType === 87 ? 'Before Work Place' : 'After Work Place'
    };
    this.isImageWorkPlaceOpen = true;
  }

  closeWorkPlaceImage() {
    this.isImageWorkPlaceOpen = false;
    this.selectedImage = null;
  }
  getFormattedTime(value: string): string {
    if (!value) return '';

    const [h, m] = value.split(':').map(Number);

    const parts: string[] = [];
    if (h > 0) {
      parts.push(`${h} hour${h > 1 ? 's' : ''}`);
    }
    if (m > 0) {
      parts.push(`${m} minute${m > 1 ? 's' : ''}`);
    }

    return parts.join(' ');
  }
}
